import { Link } from "react-router-dom";

interface Props {
  id?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  morePath?: string;
  moreLabel?: string;
}

export default function SectionHeading({ id, eyebrow, title, desc, morePath, moreLabel = "查看全部" }: Props) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-[11px] font-medium tracking-[0.2em] text-accent-700 uppercase mb-2">
            <span className="w-6 h-px bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 id={id} className="font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="text-sm text-foreground-600 mt-2 max-w-2xl">{desc}</p>}
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}